import { Pipe, PipeTransform } from '@angular/core'

/**
 * @todo: this should be re-usable in other places where we need to display avatar initials.
 *
 * Avatar initials for admin table identity cells. Falls back through
 * first/last name -> email/state_code/identifier/nickname -> '?'.
 */
@Pipe({
  name: 'initials',
})
export class InitialsPipe implements PipeTransform {
  transform(entity: any): string {
    const first = entity?.first_name?.trim?.()
    const last = entity?.last_name?.trim?.()
    if (first || last) {
      return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toLocaleUpperCase() || '?'
    }
    const source = entity?.email ?? entity?.state_code ?? entity?.identifier ?? entity?.nickname
    return source ? String(source).trim().charAt(0).toLocaleUpperCase() : '?'
  }
}
